import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'LIST_COUNT_GET',
  GET_SUCCESS: 'LIST_COUNT_GET_SUCCESS',
  GET_FAILURE: 'LIST_COUNT_GET_FAILURE',
};

export const get = actions.get(
  (url, query, meta) => `${BASE_URL}/${url}/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
